import { render, staticRenderFns } from "./MaterialInteres.vue?vue&type=template&id=ed97d4ee&scoped=true"
import script from "./MaterialInteres.vue?vue&type=script&lang=js"
export * from "./MaterialInteres.vue?vue&type=script&lang=js"
import style0 from "./MaterialInteres.vue?vue&type=style&index=0&id=ed97d4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed97d4ee",
  null
  
)

export default component.exports